export const environment = {
  production: true,
  api: 'https://api.sgf-inativos.gjbl.com.br',
};
